export function resizedAttachmentUrl(url: string, size: { width?: number, height?: number } = {}) {
    // Determine size part
    let sizePart: string | null = null
    if (size.width && size.height) {
        sizePart = `${size.width}x${size.height}`
    } else if (size.width) {
        sizePart = `${size.width}x`
    } else if (size.height) {
        sizePart = `x${size.height}`
    }

    // Check size part
    if (sizePart !== null) {
        const urlParts = url.split('/')
        urlParts.splice(-1, 0, sizePart)

        return urlParts.join('/')
    }

    return url
}

export function resizedToSizeAttachmentUrl(url: string, size: number) {
    const sizeInPixels = Math.ceil(size * 4 * window.devicePixelRatio)

    return resizedAttachmentUrl(url, { width: sizeInPixels, height: sizeInPixels })
}
